import { Injectable } from '@angular/core';
import { HttpRequest } from '@angular/common/http';
import { JwtAuthService } from './jwt-auth.service';
import { LocalStorageService } from './local-storage.service';
import { ACCESS_TOKEN_STORAGE_KEY, REFRESH_TOKEN_STORAGE_KEY } from '../store/auth-session';

@Injectable({
  providedIn: 'root'
})
export class AuthTokenService {
  constructor(
    private authService: JwtAuthService,
    private localStorageService: LocalStorageService
  ) {}

  storedAccessToken(): string | null {
    return this.localStorageService.retrieveAndDecrypt(ACCESS_TOKEN_STORAGE_KEY);
  }

  hasRefreshToken(): boolean {
    return !!this.localStorageService.retrieveAndDecrypt(REFRESH_TOKEN_STORAGE_KEY);
  }

  hasSessionToken(): boolean {
    return !!this.storedAccessToken() || this.hasRefreshToken();
  }

  isStoredTokenExpired(): boolean {
    return this.authService.isAccessTokenExpired(this.storedAccessToken());
  }

  public addTokenToRequest<T>(request: HttpRequest<T>, token: string | null): HttpRequest<T> {
    return token
      ? request.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
            'Cache-Control': 'no-cache'
          }
        })
      : request;
  }
}
